import React, { useState } from 'react';
import styles from './ContactForm.module.css';
import Button from '../Button/Button';

import pb from '../../../lib/pocketbase';

function ContactForm() {
  const [formData, setFormData] = useState({
    name: pb.authStore.model?.name || '',
    email: pb.authStore.model?.email || '',
    phone: pb.authStore.model?.phone || '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Ici, vous géreriez l'envoi du formulaire.
    // Cela nécessiterait une API backend ou un service tiers comme Formspree, Netlify Forms, etc.
    console.log('Données du formulaire soumises :', formData);
    alert('Votre message a été envoyé ! Nous vous contacterons bientôt.');
    // Réinitialiser le formulaire
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <form className={styles.contactForm} onSubmit={handleSubmit}>
      <div className={styles.formGroup}>
        <label htmlFor="name">Nom Complet</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>

      <div className={styles.formGroup}>
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>

      <div className={styles.formGroup}>
        <label htmlFor="phone">Téléphone (Optionnel)</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
        />
      </div>

      <div className={styles.formGroup}>
        <label htmlFor="subject">Sujet</label>
        <input
          type="text"
          id="subject"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          required
        />
      </div>

      <div className={styles.formGroup}>
        <label htmlFor="message">Votre Message</label>
        <textarea
          id="message"
          name="message"
          rows="6"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
      </div>

      <Button type="submit" variant="primary">Envoyer le message</Button>
    </form>
  );
}

export default ContactForm;
